// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1Lc3y","carousel__wrapper":"styles_carousel__wrapper__Qxe8I","heading__wrapper":"styles_heading__wrapper__1j8Qu"};